import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronDown } from "lucide-react";
import axios from "axios";

const ActivityDetails = ({ onBack, onSave, styles, image }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Service");
  const [clubs, setClubs] = useState([]);
  const [selectedClub, setSelectedClub] = useState("");

  const categories = ["Service", "Meeting", "Event", "Donation"];

  useEffect(() => {
    fetchClubs();
  }, []);

  const fetchClubs = async () => {
    try {
      const dist = sessionStorage.getItem("dist");
      const res = await axios.post(
        "https://lionsdirectoryapi.emedha.in/club/api/search/club",
        { search: "", dist }
      );
      setClubs(res.data);
    } catch (err) {
      console.error(err);
      alert("Error fetching clubs");
    }
  };

  const handleSubmit = () => {
    if (!title || !selectedClub) {
      alert("Please fill all required fields");
      return;
    }

    onSave({
      title,
      description,
      club: selectedClub,
      category: selectedCategory,
    });
  };

  return (
    <div style={styles.scrollArea}>
      {/* Header */}
      <div
        style={{
          backgroundColor: "#0033A0",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: "15px",
          color: "white",
        }}
      >
        <ChevronLeft onClick={onBack} style={{ cursor: "pointer" }} size={24} />
        <span style={{ fontSize: "18px", fontWeight: "500" }}>
          Activity Details
        </span>
      </div>

      {/* Image Preview */}
      <div style={{ padding: "15px" }}>
        {image && (
          <img
            src={URL.createObjectURL(image)}
            alt="Captured"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "cover",
              borderRadius: "15px",
            }}
          />
        )}
      </div>

      <div style={{ padding: "0 15px 30px" }}>
        <label>Activity Title *</label>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{ width: "100%", padding: 12, marginBottom: 15 ,borderRadius:'12px'}}
        />

        <label>Description</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          rows="4"
          style={{ width: "100%", padding: 12, marginBottom: 15 ,borderRadius:'12px'}}
        />

        <label>Select Club *</label>
        <div style={{ position: "relative", marginBottom: 20 }}>
          <select
            value={selectedClub}
            onChange={(e) => setSelectedClub(e.target.value)}
            style={{ width: "100%", padding: 12 ,borderRadius:'12px'}}
          >
            <option value="">Choose a club</option>
            {clubs.map((club) => (
              <option key={club.id} value={club.clubName}>
                {club.clubName}
              </option>
            ))}
          </select>
          <ChevronDown
            size={18}
            style={{ position: "absolute", right: 12, top: 14 }}
          />
        </div>

        <label>Category</label>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          {categories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setSelectedCategory(cat)}
              style={{
                padding: 12,
                borderRadius:'12px',
                background:
                  selectedCategory === cat ? "#FFC20E" : "#F5F5F5",
              }}
            >
              {cat}
            </button>
          ))}
        </div>

        <button
          onClick={handleSubmit}
          style={{
            width: "100%",
            marginTop: 25,
            backgroundColor: "#FFC20E",
            borderRadius:'12px',
            padding: 15,
          }}
        >
          Save & Upload
        </button>

        <button
          onClick={onBack}
          style={{
            width: "100%",
            marginTop: 10,
            borderRadius:'12px',
            border: "2px solid #0033A0",
            padding: 12,
          }}
        >
          Retake Photo
        </button>
      </div>
    </div>
  );
};

export default ActivityDetails;